<template>
    <div id="complete">
        <gotop />
        <step :stepNumber="6"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">完成投保</h2>
                <div class="insureComplete" v-if="policyType === 'INSURE'">
                    <p>親愛的客戶  您好 :</p>
                    <p class="clarity-unmask">謝謝您支持新安東京海上產險！</p>
                    <ul class="clarity-unmask completeList">
                        <li>您本次投保的要保序號為<span class="red">{{ applicationNo }}</span>，保險費為{{ formatMoney(calculate) }}元。</li>
                        <li>投保憑證已寄送至您的E-Mail信箱，您亦可由此點擊下載<a class="link" @click="pageDownloadFile">投保憑證</a>。</li>
                        <li>欲查看保單詳細資訊，可由此前往<a class="link" :href="memberUrl" target="_blank">會員專區</a>查詢保單資訊。</li>
                    </ul>
                </div>
                <div v-if="policyType === 'APPLY'">
                    <p>親愛的客戶 您好：</p>
                    <p>謝謝您支持新安東京海上產險！</p>
                    <ul class="completeList">
                        <li>您本次投保的要保序號為 <span class="red">{{ applicationNo }}</span>，保險費為{{ formatMoney(calculate) }}元。</li>
                        <li>您的保單已進入核保審核階段，請於{{ backPolicyTime }}前，依照步驟完成要保書下載、列印、簽名並回傳。(<a href="applysigntemplate_1141001.pdf" target="_blank" class="link">要保書簽名範例</a>)</li>
                        <li>要保書經審核通過且信用卡請款成功，保單即可生效。</li>
                        <li>提醒您，若未於前述時效內回傳要保書，保單將不成立，並取消您的線上要保申請。</li>
                        <li>欲查看保單詳細資訊，可由此前往<a :href="memberUrl" class="link" target="_blank">會員專區</a>查詢保單資訊。</li>
                    </ul>
                </div>
                <ul>
                    <li v-if="referrerCode === 'TAC'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=2&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬月月抽活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'BENQ'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=7&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'YULON'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=13&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬月月抽活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'ASUS'">
                        <div> <!--中文文案-->
                            投保旅遊險保戶請協助填寫
                            <a class='link' :href="surveyUrl+'surveyId=4&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                            ，了解您的保障需求，寫完問卷送出後即可獲得專屬好禮-超商禮券喔！
                        </div>
                        <div><!--英文文案-->
                            For travel insurance insured, please fill in the
                            <a class='link' :href="surveyUrl+'surveyId=4&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'  User Questionnaire】 (click here)'}}</a>
                            After completing the questionnaire, you can get a convenient store voucher!
                        </div>
                    </li>
                    <li v-else-if="referrerCode === 'DCARD'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=24&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'LINEGO'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=18&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'PCALIFE'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=22&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'GIBSIN'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=20&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'TMU' || referrerCode === 'STMU'|| referrerCode === 'YAHOOEWC'||referrerCode === 'THSRC' || referrerCode ==='CONCORDMED'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=35&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else-if="referrerCode === 'LITV'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=40&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！由此前往<a class="link" href="https://www.litv.tv/promo/tmnewalogin" target="_blank">【LiTV活動頁面】</a>登錄完畢再享 LiTV 電視頻道餐 30 天體驗序號！
                    </li>
                    <li v-else-if="referrerCode === 'IRICH'|| referrerCode === 'KKDAY'||referrerCode === 'YAHOOEBO'||referrerCode === 'MXIC'||referrerCode === 'UPEWC'">
                        為更加了解客戶需求，請協助填寫
                        <a class='link' :href="surveyUrl+'surveyId=40&applicationNo='+applicationNo" target="_blank">{{'【'+referrerCode+'專屬問卷】 (請點選)'}}</a>
                        ，填寫完後送出即可參加專屬抽獎活動，好禮等你帶回家！
                    </li>
                    <li v-else>為提供顧客更好的網路投保服務，希望透過此<a
                        :href="'https://www.tmnewa.com.tw/ec/campaign/survey2020/index.html?policyNo='+applicationNo" class="link complete_qa_accu" target="_blank">滿意度調查問卷</a>了解您的體驗，您的寶貴意見將作為我們參考的重要資料，謝謝！
                    </li>
                </ul>
                <div v-if="policyType === 'APPLY'">
                    <div class="attentionTxt">
                        <img src="noticemark.svg" class="attention" alt="">
                        <div>
                        旅程中若有租用汽車的需求，別忘了投保【<span><a @click="otherAlert('LUCKYBO')">短期租借車保險</a></span>】，保障您的行車安全，讓旅程更安心。
                        </div>
                    </div>
                    <div class="btnArea">
                        <div class="anotherBtn">
                            <a class="btn confirm" target="_blank" @click="pageDownloadFile">要保書下載</a>
                        </div>
                    </div>
                    <h3 class="blueTitle">要保書回傳方式</h3>
                    <p>要保書簽名及回覆方式說明如下：</p>
                    <div class="uploadWay">
                        <img src="../assets/qrcode.svg" alt="" class="uploadWayPic">
                        <div class="uploadWayList">
                            <ul>
                                <li>確認要保書資料並完成所有簽名。</li>
                                <li>清晰拍下整份要保書(共2頁)。</li>
                                <li>手機掃描要保書右上方的QR code，點擊連結開啟網頁。</li>
                                <li>登入會員並通過驗證。</li>
                                <li>找到您的保單並選擇<a :href="memberUrl" target="_blank" class="link complete_upload_accu">上傳文件</a>。</li>
                                <li>上傳要保書。</li>
                            </ul>
                            <div class="attentionTxt">
                                <img src="noticemark.svg" class="attention" alt="">
                                <div>
                                    從手機下載的檔案在哪？怎麼打開？請參考<span><a @click="otherAlert('IOS')">iOS</a></span> / <span><a @click="otherAlert('ANDROID')" target="_blank">Android</a></span> 教學。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="policyType==='INSURE'" class="attentionTxt">
                    <img src="noticemark.svg" class="attention" alt="">
                    <div>
                        旅程中若有租用汽車的需求，別忘了投保【<span><a @click="otherAlert('LUCKYBO')">短期租借車保險</a></span>】，保障您的行車安全，讓旅程更安心。
                    </div>
                </div>
                <div v-if="policyType==='INSURE'" class="attentionTxt">
                    <img src="noticemark.svg" class="attention" alt="">
                    <div>
                        從手機下載的檔案在哪？怎麼打開？請參考<span><a @click="otherAlert('IOS')">iOS</a></span> / <span><a @click="otherAlert('ANDROID')" target="_blank">Android</a></span> 教學。
                    </div>
                </div>
                <div class="clarity-unmask completeBottom">
                    <p>如有任何疑問，歡迎與我們聯繫。</p>
                    <div>網路服務專線：0800-366-168 / 服務時間：週一至週五上午8:30-下午5:30(國定假日除外)</div>
                </div>

            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
<!--                <a class="btn confirm complete_download_accu" target="_blank" v-if="policyType === 'INSURE'" @click="pageDownloadFile">下載投保憑證</a>-->
<!--                <a class="btn confirm complete_download_accu" target="_blank" v-if="policyType === 'APPLY'" @click="pageDownloadFile">下載要保書</a>-->
                <router-link :to="'/'" class="btn confirm complete_home_accu">回首頁</router-link>
            </div>
        </div>
    </div>
</template>
<script setup>
        import gotop from "@/components/gotop.vue";
        import step from "@/components/step.vue";
        import { postApi, downloadFile } from "@/utils/callApi";
        import moment from "moment/moment";
        import {popUp} from "@/utils/popUp";
        import {onMounted, onUnmounted, ref} from "vue";
        import gtm from "@/utils/gtmDataLayer";
        import apiConfig from "@/utils/apiConfig";
        import Swal from "sweetalert2";


        let confirmStorage = JSON.parse(sessionStorage.getItem("confirmStorage"));//最終資料
        let jwtInfo = {};

        const applicationNo = ref(sessionStorage.getItem("applicationNo"));
        const policyType = ref(sessionStorage.getItem("confirmPolicyType"));
        const surveyUrl = ref(process.env.VUE_APP_SURVEY);
        //const orderUrl = ref(process.env.VUE_APP_ORDER);
        const memberUrl = ref(process.env.VUE_APP_DOMAIN+process.env.VUE_APP_MEMBER+'#travel');
        const referrerCode = ref("");
        const countDays = ref("");
        const applicantData = ref({});
        const calculate = ref("");
        const backPolicyTime = ref("");

        const loadStorage = () => {
            if (confirmStorage != null) {
                referrerCode.value = confirmStorage.referrerCode;
                countDays.value = confirmStorage.countDays;
                if (confirmStorage.applicantData != null) {
                    applicantData.value = confirmStorage.applicantData;
                }
                if (confirmStorage.totalPremium != null) {
                    calculate.value = confirmStorage.totalPremium;
                }
            }
            createPolicy();
        }
        const createPolicy = () =>{
            var data = {
                'applicationNo': applicationNo.value,
            };
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            postApi(apiConfig.createPolicyDoc,jwtInfo.token, null, null, data)
                .then((response) => {
                    var createPolicyDocRes = response.data;
                    if (createPolicyDocRes.code === 200) {
                        var date = createPolicyDocRes.data.backPolicyDueTime;
                        backPolicyTime.value = moment(date).format('YYYY[年]MM[月]DD[日] HH[時]mm[分]');
                        sendSuccessMail();
                    } else {
                        Swal.fire({
                            title: "取得要保書/投保憑證錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ createPolicyDocRes.message + '</p>',
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "取得要保書/投保憑證錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>取得要保書/投保憑證連線錯誤</p>',
                    })
                });
        }
        const sendSuccessMail = () =>{
            var data = {
                'applicationNo': applicationNo.value,
            };
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            postApi(apiConfig.sendSuccessMail, jwtInfo.token, null, null, data)
                .then((response) => {
                    var sendSuccessMailRes = response.data;
                    if (sendSuccessMailRes.code === 200) {
                        //do nothing
                    } else {
                        Swal.fire({
                            title: "發送要保書/投保憑證錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ sendSuccessMailRes.message + '</p>',
                        })
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "發送要保書/投保憑證錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>發送要保書/投保憑證連線錯誤</p>',
                    })
                });
        }
        // 總保費加上千分位號","
        const formatMoney = (value) => {
            if (value === null || value === undefined) return null;
            return parseFloat(value).toLocaleString("zh-TW", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 50,
            });
        };
        const pageDownloadFile = () =>{
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            downloadFile(apiConfig.downloadPolicy + '/' + applicationNo.value, jwtInfo.token)
                .then((response) => {
                    const file = window.URL.createObjectURL(new Blob([response.data]));
                    const docUrl = document.createElement('a');
                    docUrl.href = file;
                    docUrl.setAttribute('download', applicationNo.value + '.pdf');
                    document.body.appendChild(docUrl);
                    docUrl.click();
                })
                .catch(() => {
                    Swal.fire({
                        title: "下載要保書/投保憑證錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>系統忙碌無法即時下載檔案，請稍候15~30分鐘系統將會自動發送檔案至您的信箱。</p>',
                    }).then(()=>{
                        window.location.reload();
                    });
                });
        }
        const maskName = (name) => {
            const char = name.toString().split('');
            let maskName = "";
            char.forEach((c,i) =>{
                if(i === 1){
                    maskName = maskName + 'Ｏ'
                }else{
                    maskName = maskName + c;
                }
            });
            return maskName;
        }
        // 跳出離開系統提醒視窗
        const otherAlert=(type)=>{
            Swal.fire({
                title: "提醒您",
                showConfirmButton: true,
                showCancelButton: true,
                showCloseButton: true,
                reverseButtons:true,
                cancelButtonText: '返回',
                confirmButtonText: '確認前往',
                html: '<img src="infomark.svg"><p>您即將離開新安東京海上線上投保網站</p>',
            }).then((result) => {
                if (result.isConfirmed) {
                    if(type==='IOS'){
                        window.open('https://support.apple.com/zh-tw/102440','_blank');
                    }else if(type==='ANDROID'){
                        window.open('https://www.adobe.com/tw/acrobat/hub/resources/where-to-find-pdfs-android.html','_blank');
                    }else if(type==='LUCKYBO'){
                        window.open('https://www.luckybo.com/car?promote=&utm_source=tmnewa&utm_medium=sucesspage&utm_campaign=ec_travel&utm_content=tra_package','_blank');
                    }
                } else if (result.isDenied) {
                    Swal.close();
                }
            });
        }

        loadStorage();

        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
        })

        onUnmounted(()=>{
            let removeStorage = ['detailStorage','pageStorage','otp','fromPage'];
            removeStorage.forEach(k =>
                sessionStorage.removeItem(k)
            )
        })

</script>

<style lang="scss">
#complete {
    .content {
        line-height: 32px;
        font-size: 16px;
    }
    .completeList{
        box-sizing: border-box;
        list-style-type: disc;
        padding-left: 25px;
    }
    .completeBottom{
        margin-top:50px;
    }
    .blueArea {
        background: $blue-400;
        border: 2px solid rgba(206, 228, 242, 0.89);
        padding: 10px;
        box-sizing: border-box;
        margin: 20px 0;

        .btnArea {
            margin-bottom: 10px;
        }
        @media screen and (max-width: 700px){
            .anotherBtn .btn{
                margin:0 10px;
            }
        }
        @media screen and (max-width: $small) {
            .anotherBtn .btn {
                width: 75%;
                margin: 10px;
            }
        }
    }

    .blueTitle {
        h3 {
            color: $blue-700;
            margin: 0;
            font-size: 30px;
          font-weight:500;
        }

        h4 {
            color: $pink;
            margin: 0;
            font-size: 30px;
           font-weight:500;
        }

        @media screen and (max-width: $small) {
            line-height: 25px;

            h3 {
                font-size: 16px;
            }

            h4 {
                font-size: 16px;
            }
        }
    }

    .uploadWay {
        display: flex;
        align-items: center;
        margin: 30px 0;

        .uploadWayList {
            margin-left: 30px;
            ul{
                line-height: 30px;
                list-style-type: decimal;
                list-style-position: inside;
            }
        }

        .blue {
            color: $blue-700
        }
      @media screen and (max-width: $small) {
          display: block;

        .uploadWayPic{
            display: block;
            padding: 30px 0;
            margin: 0 auto;
        }
          .uploadWayList{
              margin: 0;
          }
      }
    }


}
</style>
